import { Loader2 } from "lucide-react";

export default function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1E3A5F] to-[#0F2744]">
      <div className="text-center">
        <div className="relative">
          {/* Spinning loader */}
          <Loader2 className="w-12 h-12 text-[#F9A825] animate-spin mx-auto" />
          
          {/* Glow effect */}
          <div className="absolute inset-0 w-12 h-12 mx-auto bg-[#F9A825]/20 rounded-full blur-xl animate-pulse"></div>
        </div>
        
        <p className="mt-4 text-white/70 text-sm font-medium">Cargando...</p>
      </div>
    </div>
  );
}
